import { Footer } from '@mashvisor/design-system';

export default Footer;
